










import AssistantSetup from '@/components/AssistantSetup.vue'
import Leaderboard from '@/components/Leaderboard.vue'

export default
    name: 'TabPage'
    components:
        AssistantSetup: AssistantSetup
        Leaderboard: Leaderboard
    data: ->
        # tabs: ['Configurer les assistants', 'Leaderboard']
        tabs: ['Leaderboard', 'Configurer les assistants']
        selectedTab: 'Leaderboard'
        selected_assistant_uid: null
    # computed:
    #     selectedTabComponent: ->
    #         switch @selectedTab
    #             when 'Configurer un assistant' then 'AssistantSetup'
    #             when 'Leaderboard' then 'Leaderboard'
    methods:
        selectTab: (tab) ->
            @selectedTab = tab
        show_assistant_detail: (uid) ->
            @selected_assistant_uid = uid
            @selectTab 'AssistantSetup'
